import type {PerkUsageViewComponentProps} from '@cohort/merchants/apps';
import {PerkUsageLayout} from '@cohort/merchants/components/perks/PerkUsageLayout';
import {useCurrentMerchant} from '@cohort/merchants/hooks/contexts/currentMerchant';
import type {CohortLinkConfig} from '@cohort/shared/apps/cohort/perks/link';
import {useTranslation} from 'react-i18next';

const CohortLinkPerkIntegrationsUsageViewComponent: React.FC<PerkUsageViewComponentProps> = ({
  usage,
}) => {
  const merchant = useCurrentMerchant();
  const config = usage.integrationConfig as CohortLinkConfig;
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'perkIntegrations.link.usageViewComponent',
  });
  return (
    <PerkUsageLayout.Grid>
      <PerkUsageLayout.Row
        name={t('userVisitedLink')}
        value={config.url[merchant.defaultLanguage]}
      />
    </PerkUsageLayout.Grid>
  );
};

export default CohortLinkPerkIntegrationsUsageViewComponent;
